import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom'; // এখানে যোগ করো
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter> {/* App পুরোটা Router context এর মধ্যে */}
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

reportWebVitals();
